module.exports = __webpack_public_path__ + "img/iohk.755d38a9.png";